// Task pane header baseline used across layout calculations.
export const HEADER_HEIGHT = 32

/** Minimum visible editor height (two lines). Matches .trumbowyg-editor minHeight in ChatInput.styles. */
export const CHAT_INPUT_EDITOR_MIN_HEIGHT_PX = 40

// The ChatInput box never gets shorter than this, even in a tiny task pane.
export const CHAT_INPUT_MIN_HEIGHT_PX = 120

/** Home's footer (ChatInput + review button) takes at most this percent of the page height. */
export const CHAT_FOOTER_MAX_HEIGHT_PERCENT = 90

export const CHAT_INPUT_CONTEXT_PANEL = {
  // Auto-sizing: proportional to page height; keeps context proportional until manual resize.
  autoCapViewportRatio: 0.15,
  keyboardStep: 12,
} as const

function getPageHeightPx(): number {
  const layout = document.querySelector<HTMLElement>('[data-home-layout]')
  // clientHeight is 0 before Home has laid out, and always in jsdom.
  return layout?.clientHeight || window.innerHeight
}

/**
 * Tallest the ChatInput box may get, in px.
 *
 * The footer may take CHAT_FOOTER_MAX_HEIGHT_PERCENT of the page. The ChatInput box gets that
 * minus what sits in the footer below it: the review button row, the gap above it and the
 * footer's bottom padding.
 */
export function measureChatInputMaxHeightPx(): number {
  const footerMaxHeight = Math.floor((getPageHeightPx() * CHAT_FOOTER_MAX_HEIGHT_PERCENT) / 100)
  const footer = document.querySelector<HTMLElement>('[data-chat-footer]')
  if (!footer) {
    return Math.max(CHAT_INPUT_MIN_HEIGHT_PX, footerMaxHeight)
  }

  const reviewHeight = footer.querySelector<HTMLElement>('[data-review-section]')?.offsetHeight ?? 0
  const footerStyles = window.getComputedStyle(footer)
  const gapAboveReview = reviewHeight > 0 ? Number.parseFloat(footerStyles.rowGap) || 0 : 0
  const paddingBottom = Number.parseFloat(footerStyles.paddingBottom) || 0

  const belowChatInput = reviewHeight + gapAboveReview + paddingBottom
  return Math.max(CHAT_INPUT_MIN_HEIGHT_PX, footerMaxHeight - belowChatInput)
}

/** How tall the context list grows on its own, before any drag. */
export function measureContextAutoCapPx(): number {
  return Math.floor(getPageHeightPx() * CHAT_INPUT_CONTEXT_PANEL.autoCapViewportRatio)
}
